export default {
  paperWidthSm: {
    maxWidth: 630,
  },
  paperWidthFalse: {
    width: 'auto',
  },
};
